'use client';

import useRunOnce from './hooks/useRunOnce';
import dispatchGoogleAnalyticsEvent, { gaEvents, gaFormatters } from '../../modules/analytics/google/dispatchGoogleAnalyticsEvent';
import { FormatSelectedConditionAnalytics } from '../../modules/analytics/google/formatters/formatSelectedConditionAnalytics';

/**
 * Runs analytics for the condition page.
 * @see src/app/(site)/[dynamicRoute]/page.tsx
 */
const ConditionPageAnalytics = (props: FormatSelectedConditionAnalytics) => {
    // Run a google analytics event that pushes the view_category event to google analytics with the condition
    // detail and information about the products on the page.
    useRunOnce(() => dispatchGoogleAnalyticsEvent(gaEvents.SelectedProduct, gaFormatters.selectedConditionPage(props)));

    return null;
};

export default ConditionPageAnalytics;
